var _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIEdit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.1427 8C12.8271 8 12.5712 8.25583 12.5712 8.57143V14.2856C12.5712 14.6012 12.3154 14.857 11.9998 14.857H1.71426C1.39866 14.857 1.14283 14.6012 1.14283 14.2856V2.85721C1.14283 2.54161 1.39866 2.28577 1.71426 2.28577H8.57132C8.88691 2.28577 9.14275 2.02994 9.14275 1.71434C9.14275 1.39874 8.88691 1.14294 8.57132 1.14294H1.71426C0.767501 1.14294 0 1.91045 0 2.85721V14.2856C0 15.2324 0.767501 15.9999 1.71426 15.9999H11.9998C12.9466 15.9999 13.7141 15.2324 13.7141 14.2856V8.57139C13.7141 8.25583 13.4583 8 13.1427 8Z",
    fill: "#00427D"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.3594 0.640904C14.9491 0.230552 14.3926 6.41473e-05 13.8123 0.000131111C13.2317 -0.00154297 12.6746 0.229347 12.2655 0.641272L4.73869 8.16742C4.67625 8.23034 4.62914 8.30681 4.60098 8.39085L3.45815 11.8194C3.35841 12.1188 3.5203 12.4424 3.81972 12.5421C3.87781 12.5614 3.93865 12.5713 3.99985 12.5714C4.06119 12.5713 4.12216 12.5614 4.18042 12.5422L7.60895 11.3994C7.69315 11.3713 7.76966 11.3239 7.83237 11.2611L15.3591 3.73438C16.2134 2.88019 16.2135 1.49519 15.3594 0.640904ZM14.5511 2.92693L7.12266 10.3554L4.90326 11.0965L5.6421 8.87998L13.0734 1.45153C13.482 1.04379 14.1437 1.04446 14.5515 1.453C14.7462 1.64817 14.856 1.91237 14.8568 2.18809C14.8575 2.46529 14.7475 2.73127 14.5511 2.92693Z",
    fill: "#00427D"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIEdit);
export default __webpack_public_path__ + "static/media/i_edit.2f22c76bde6416d9b6fc6ab8bf0541f3.svg";
export { ForwardRef as ReactComponent };